export default function NetworksAndCoins({
  selectedChain,
  selectedToken,
  onSetNetwork,
  onSetCrypto,
  setActiveTab,
  cryllexChains,
}) {

  return (<div>
    <div className="mb-3 title-block">
      <strong >Select Network & Token</strong>
    </div>

    <div className="p-3 text-dark  mb-5">
      <div>{
        cryllexChains && cryllexChains.length ?
          <div>
            <div>
              <p className='fw-500'>Networks</p>
              <ul className="cx-accordion-body-list flex-wrap" id="crypto-block">
                {
                  cryllexChains.map((item) => {
                    return <li
                      key={item.id}
                      title={item.chainName}
                      style={{ cursor: "pointer" }}
                      className={`cx-accordion-list-item px-3 pt-3 mb-3 ${selectedChain && selectedChain.id === item.id ? "selected-item" : ""}`}
                      onClick={() => {
                        onSetNetwork(item, setActiveTab);
                      }}
                    >
                      <img src={item.chainLogo} alt="logo" className='rounded' />
                      <div className="cx-accordion-list-item-name">
                        {item.chainSlug}
                      </div>
                    </li>
                  })
                }
              </ul>
            </div>
            {
              selectedChain && selectedChain.tokens && selectedChain.tokens.length ?
                <div>
                  <hr />
                  <p className='fw-500'>Tokens</p>
                  <ul className="cx-accordion-body-list" id="crypto-block">
                    {
                      selectedChain.tokens.map(item => {
                        return <li
                          title={item.name}
                          style={{ cursor: "pointer" }}
                          key={item.id}
                          className={`cx-accordion-list-item pt-3 ${selectedToken && selectedToken.id === item.id ? "selected-item" : ""}`}
                          // onClick={() => setSelectedToken(item)}
                          onClick={() => onSetCrypto(item, setActiveTab)}
                        >
                          <img src={item.logo} alt="logo" className='rounded' />
                          <div className="cx-accordion-list-item-name" >
                            {item?.slug}
                          </div>
                        </li>
                      })
                    }
                  </ul>
                </div>
                : null
            }
          </div>
          : null
      }</div>
    </div>
  </div>



  )
}
